
const width = window.innerWidth;
const getWidthCreateDate = () => {
    switch (width){
        case 1920:
            return 200
        case 1792:
        case 1680:
        case 1600:
            return 180
        case 1536:
            return 150
        case 1440:
            return 160
        case 1366:
            return 170
        default:
            return ""
    }
}
const getWidthName= () => {
    switch (width){
        case 1920:
            return 634
        case 1792:
            return 534
        case 1680:
            return 500
        case 1600:
            return 450
        case 1536:
            return 350
        case 1440:
            return 300
        case 1366:
            return 250
        default:
            return ""
    }
}

const getWidthDate= () => {
    switch (width){
        case 1920:
        case 1792:
        case 1680:
        case 1600:
        case 1536:
        case 1440:
        case 1366:
            return 125
        default:
            return ""
    }
}
const getWidthAccountName= () => {
    switch (width){
        case 1920:
            return 380
        case 1792:
            return 300
        case 1680:
        case 1600:
            return 250
        case 1536:
            return 130
        case 1440:
            return 140
        case 1366:
            return 150
        default:
            return ""
    }
}

export const columns = [
    {
        title: "Tên báo cáo",
        dataIndex: "name",
        ellipsis: true,
        width: getWidthName()
    },
    {
        title: "Từ ngày",
        dataIndex: "startDate",
        ellipsis: true,
        width: getWidthDate()
    },
    {
        title: "Đến ngày",
        dataIndex: "endDate",
        ellipsis: true,
        width: getWidthDate()
    },
    {
        title: "Người tạo",
        dataIndex: "accountName",
        ellipsis: true,
        width: getWidthAccountName()
    },
    {
        title: "Thời gian tạo",
        dataIndex: "createDate",
        ellipsis: true,
        width: getWidthCreateDate()
    },
    {
        dataIndex: "menu",
        width: 120,
        onCell: record => {
            return {
                onClick: event => {
                    event.stopPropagation();
                }
            }
        },
    },
];
